import {createLogger, StringifyObjectsHook} from 'vue-logger-plugin';
import axios from 'axios';

// send logs to the server
// const serverLogHook = {
//   async run(event) {
//     await axios
//       .post('/api/log/client', {caller: event.caller, level: event.level, page: event.argumentArray[0], data: event.argumentArray})
//       .then((response) => {});
//   },
// };

// create logger with options
const logger = createLogger({
  enabled: true, //로거 활성화/ 비활성화
  level: 'debug', //로깅 레벨
  consoleEnabled: true, //콘솔 출력 활성화 비활성화
  callerInfo: true, //호출 함수 정보 포함 여부

  beforeHooks: [StringifyObjectsHook], // Hook
  // afterHooks: [serverLogHook],
});

export default logger;
